:host {
  display: inline-block ;
}

@mixin default-button-settings {
  background: none;
  border: none;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  column-gap: 10px;
  padding: 0;
}

.btn {
  @include default-button-settings();
  @include supportedTypography();

  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 10px;
    padding: 2px 8px;
    height: 0; // btn height would be set by padding in the button itself, content should not interfere with height calculation
  }

  &.primary {
    color: var(--color-white);
    background: var(--color-nero);

    &:hover {
      opacity: 0.7;
    }

    &.outline {
      color: var(--color-nero);
      background: transparent;
      .loading-container svg {
        stroke: var(--color-nero);
      }

      border: 1px solid var(--color-nero);
    }
  }

  &.secondary {
    color: var(--color-nero);
    background: var(--color-white);
    .loading-container svg {
      stroke: var(--color-nero);
    }

    &.outline {
      color: var(--color-white);
      background: transparent;
      border: 1px solid var(--color-white);
    }
  }

  &.supercard {
    color: var(--color-white);
    background: var(--color-supercard);

    &.outline {
      color: var(--color-supercard);
      background: transparent;
      .loading-container svg {
        stroke: var(--color-nero);
      }
      border: 1px solid var(--color-supercard);
    }

    &:hover {
      opacity: 0.7;
    }
  }

  &.orderdetail {
    white-space: nowrap;
    @include breakpointMax('sm') {
      width: 100% !important;
    }
    .content {
      @include breakpointMin('sm') {
        padding: 6px 60px;
      }
    }
  }

  &.sticky-add-to-cart {
    @include breakpointMax('sm') {
      width: 40px !important;
    }
    .text {
      display: none;
      @include breakpointMin('sm') {
        display: block;
      }
    }
  }

  &.gradient {
    color: var(--color-white);
    background-image: linear-gradient(to right, var(--color-gradient-dark), var(--color-gradient-light), var(--color-gradient-dark));
    background-size: 200% 100%;
    background-position: left;
    transition: 0.5s;

    &:hover {
      background-position: right;
    }
  }

  &.h {
    &-sm {
      padding: 16px 0px;
      .text.size-14.lg-size-16.lowercase {
        margin-top: -3px;
      }
    }

    &-lg {
      padding: 20px 0px;
    }
  }

  &.w {
    &-fixed {
      width: 200px;
    }

    &-fit-content {
      width: fit-content;
      height: fit-content;
    }

    &-mobile-full-width {
      width: 100%;

      @include breakpointMin('md') {
        min-width: 200px;
        width: fit-content;
      }
    }

    &-full-width {
      width: 100%;
    }

    &-max-330 {
      max-width: 20.625rem;
    }
  }

  .text {
    font-family: var(--primary-font);
    line-height: 1; // handle text centering with padding in the button, not setting the line-height. Creates problems when adding icons or element to the slot

    &.uppercase {
      text-transform: uppercase;
      transform: translateY(1px); // baseline descender is bigger than expected when all is uppercase. Check https://css-tricks.com/how-to-tame-line-height-in-css/ for a picture
    }

    &.lowercase {
      text-transform: lowercase;
    }

    &.capitalize {
      text-transform: capitalize;
    }
  }
}

.button-select-modal {
  position: absolute;
  display: none;
  z-index: 998;
  max-width: 280px;
  padding: 5px 0 5px 0;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  -webkit-box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  -moz-box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  background-color: var(--color-white);
  border-radius: 5px;

  @include breakpointMin('sm') {
    max-width: 361px;
  }
  @include breakpointMin('md') {
    max-width: 388px;
  }
  ul {
    margin: 0;
    padding: 0;

    .option {
      padding-left: 5px;
      padding-right: 5px;
      color: var(--color-gradient-dark);
      cursor: pointer;
      list-style: none;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      lilu-icon {
        visibility: hidden;
      }

      &[aria-selected="true"] {
        lilu-icon {
          visibility: visible;
        }
      }

      .option-container {
        display: flex;
        align-items: center;
        gap: 5px;
        padding:5px;
        padding-right: 40px;
        line-height: 16px;

        &.active {
          border-radius: 5px;
          background-color: var(--color-gradient-dark);
          color: var(--color-white);
        }
      }

    }
  }
  &.isOpen {
    display: block;
  }
}
